<!--  (keyup)="submit($event)" -->
<footer class="footer">
  <form class="row form">
    <input
      #inputFromUser
      (keyup.enter)="submit($event)"
      class="input"
      type="text"
      placeholder="Enter your message here"
    />
    <button
      (click)="handleClickEvent($event)"
      class="btn btnSend"
      type="submit"
    >
      <i class="fa fa-paper-plane"></i>
    </button>
  </form>
</footer>
